var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.access)?_c('router-link',{attrs:{"to":'/' + _vm.endpoint}},[_c('a',{staticClass:"nav-item nav-link",on:{"click":_vm.redirect}},[_vm._v(_vm._s(_vm.label))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }